import { createFileRoute, notFound } from "@tanstack/react-router"
import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from "react"
import { type LegacySlug } from "~/pages/design-system/legacy-components/catalog"

const PAGES: Record<LegacySlug, LazyExoticComponent<ComponentType>> = {
  cards: lazy(() => import("~/pages/design-system/legacy-components/Cards")),
  loading: lazy(() => import("~/pages/design-system/legacy-components/Loading")),
  dialogs: lazy(() => import("~/pages/design-system/legacy-components/Dialogs")),
  select: lazy(() => import("~/pages/design-system/legacy-components/Select")),
  tables: lazy(() => import("~/pages/design-system/legacy-components/Tables")),
  breadcrumb: lazy(() => import("~/pages/design-system/legacy-components/Breadcrumb")),
  forms: lazy(() => import("~/pages/design-system/legacy-components/Forms")),
  image: lazy(() => import("~/pages/design-system/legacy-components/Image")),
  separator: lazy(() => import("~/pages/design-system/legacy-components/Separator")),
  tabs: lazy(() => import("~/pages/design-system/legacy-components/Tabs")),
  popover: lazy(() => import("~/pages/design-system/legacy-components/Popover")),
  alert: lazy(() => import("~/pages/design-system/legacy-components/Alert")),
  "empty-states": lazy(() => import("~/pages/design-system/legacy-components/EmptyStates")),
  "dropdown-menu": lazy(() => import("~/pages/design-system/legacy-components/DropdownMenu")),
  accordion: lazy(() => import("~/pages/design-system/legacy-components/Accordion")),
  "action-button": lazy(() => import("~/pages/design-system/legacy-components/ActionButton")),
  drawer: lazy(() => import("~/pages/design-system/legacy-components/Drawer")),
  "information-rows": lazy(() => import("~/pages/design-system/legacy-components/InformationRows")),
  progress: lazy(() => import("~/pages/design-system/legacy-components/Progress")),
  slider: lazy(() => import("~/pages/design-system/legacy-components/Slider")),
  "year-selector": lazy(() => import("~/pages/design-system/legacy-components/YearSelector")),
  trend: lazy(() => import("~/pages/design-system/legacy-components/Trend")),
  item: lazy(() => import("~/pages/design-system/legacy-components/Item")),
  calendar: lazy(() => import("~/pages/design-system/legacy-components/Calendar")),
  tooltips: lazy(() => import("~/pages/design-system/legacy-components/Tooltips")),
  "hover-cards": lazy(() => import("~/pages/design-system/legacy-components/HoverCards")),
}

const isLegacySlug = (slug: string): slug is LegacySlug => slug in PAGES

export const Route = createFileRoute("/_auth/internal/design-system/legacy-components/$slug")({
  staticData: { skipSkuStoreData: true },
  params: {
    parse: ({ slug }) => {
      if (!isLegacySlug(slug)) throw notFound()
      return { slug }
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { slug } = Route.useParams()
  const Page = PAGES[slug]
  return (
    <Suspense>
      <Page />
    </Suspense>
  )
}
